export default __webpack_public_path__ + "static/media/Group 11708.e88eee24.svg";